"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Default data for the `MaterialTable.localization` attribute
 */
var _default = {
  error: 'Data could not be retrieved',
  grouping: {
    groupedBy: 'Grouped By:',
    placeholder: 'Drag headers here to group by'
  },
  pagination: {
    labelDisplayedRows: '{from}-{to} of {count}',
    labelRowsPerPage: 'Rows per page:',
    labelRows: 'rows',
    firstAriaLabel: 'First Page',
    firstTooltip: 'First Page',
    previousAriaLabel: 'Previous Page',
    previousTooltip: 'Previous Page',
    nextAriaLabel: 'Next Page',
    nextTooltip: 'Next Page',
    lastAriaLabel: 'Last Page',
    lastTooltip: 'Last Page'
  },
  toolbar: {
    addRemoveColumns: 'Add or remove columns',
    nRowsSelected: '{0} row(s) selected',
    showColumnsTitle: 'Show Columns',
    showColumnsAriaLabel: 'Show Columns',
    exportTitle: 'Export',
    exportAriaLabel: 'Export',
    searchTooltip: 'Search',
    searchPlaceholder: 'Search',
    searchAriaLabel: 'Search',
    clearSearchAriaLabel: 'Clear Search'
  },
  header: {
    actions: 'Actions'
  },
  body: {
    emptyDataSourceMessage: 'No records to display',
    editRow: {
      saveTooltip: 'Save',
      cancelTooltip: 'Cancel',
      deleteText: 'Are you sure you want to delete this row?'
    },
    filterRow: {},
    dateTimePickerLocalization: 'Filter',
    addTooltip: 'Add',
    deleteTooltip: 'Delete',
    editTooltip: 'Edit',
    bulkEditTooltip: 'Edit All',
    bulkEditApprove: 'Save all changes',
    bulkEditCancel: 'Discard all changes'
  }
};
exports["default"] = _default;